import type { KnowledgeBaseDocumentFieldsFragment } from '~/api/graphql';

type KnowledgeBaseDocumentDisplayTitleSource = Pick<
  KnowledgeBaseDocumentFieldsFragment,
  'displayName' | 'title'
> & {
  metadata?: Pick<NonNullable<KnowledgeBaseDocumentFieldsFragment['metadata']>, 'title'> | null;
};

const firstNonBlank = (...values: Array<string | null | undefined>): string => {
  for (const value of values) {
    if (value != null && value.trim() !== '') {
      return value;
    }
  }
  return '';
};

export const getKnowledgeBaseDocumentDisplayTitle = (
  document: KnowledgeBaseDocumentDisplayTitleSource
): string => firstNonBlank(document.displayName, document.metadata?.title, document.title);

const displayNameMaxLength = 100;

export type KnowledgeBaseDocumentDisplayNameUpdateState = {
  canSubmit: boolean;
  submitDisplayName: string;
  isOverLimit: boolean;
};

export const resolveKnowledgeBaseDocumentDisplayNameUpdate = ({
  input,
  storedDisplayName,
  displayedTitle
}: {
  input: string;
  storedDisplayName: string | null | undefined;
  displayedTitle: string;
}): KnowledgeBaseDocumentDisplayNameUpdateState => {
  const trimmedInput = input.trim();
  const hasOverride = (storedDisplayName ?? '').trim() !== '';
  const isOverLimit = Array.from(trimmedInput).length > displayNameMaxLength;
  const isUnchanged = trimmedInput === displayedTitle.trim();
  const isClear = trimmedInput === '';

  if (isOverLimit || isUnchanged || (isClear && !hasOverride)) {
    return {
      canSubmit: false,
      submitDisplayName: trimmedInput,
      isOverLimit
    };
  }

  return {
    canSubmit: true,
    submitDisplayName: isClear ? '' : trimmedInput,
    isOverLimit: false
  };
};
